<template>
    <div class="form-layout">
        <transition-group name="list">
            <div v-bind:key="step" v-for="(field, increment) in data" class="fields" :id="field.name" :class="{'half': data.length > 1 && (field.type != 'radio' || (field.hasOwnProperty('half') && field.half)) && field.type != 'textarea' && field.type != 'checkbox','right': increment % 2 && !field.hasOwnProperty('dependant'), 'dropdown': field.type == 'select', 'has-error': errors.has(field.name), 'selection': field.type == 'radio', 'input': field.type == 'text' || field.type == 'date' }" v-if="!field.hasOwnProperty('dependant') || participant[field.dependant.name] == field.dependant.value" :data-field="field.name">
                <label :class="{ 'no-prompt': !(field.hasOwnProperty('pro_show') && field.pro_show && (field.hasOwnProperty('prompt') && field.prompt)) && !(field.hasOwnProperty('prompt') && field.prompt) }" :for="field.name" v-show="(field.hasOwnProperty('pro_button') && (field.hasOwnProperty('pro_show') && field.pro_show)) || !field.hasOwnProperty('pro_button')">{{ field.placeholder }} <b v-if="required_fields[field.name] != undefined && required_fields[field.name].indexOf('required') > -1">*</b></label>
                <p v-if="(field.hasOwnProperty('pro_show') && field.pro_show && (field.hasOwnProperty('prompt') && field.prompt)) || (field.hasOwnProperty('prompt') && field.prompt)" v-html="field.prompt || field.description"></p>
                <a class="cta-button blue cannot-find-school" @click="field.pro_show = true" v-if="field.hasOwnProperty('pro_button') && !field.pro_show">{{ field.pro_button }}</a>
                <div v-else-if="field.type == 'select'" class="dropdown-inner" :class="{ 'selected': school != null && school != '' }">
                    <v-select :value="( participant['school_id'] ? { id: participant['school_id'], name: participant['school_readable']} : null )" :on-change="newSchoolChosen" label="name" :on-search="getSchools" :options="schools" placeholder="Type atleast 2 letters to find a school"></v-select>
                    <input type="hidden" :name="field.name" :id="field.name" v-model="school" v-validate="{ rules: ( required_fields[field.name] ? (required_fields[field.name]).join('|') : '' ) }">
                </div>
                <div v-else-if="field.type == 'date'">
                    <div class="fields input dob-date" :class="{'has-error': errors.has(field.name) }" v-bind:key="2">
                        <input type="number" v-model="dob.date" v-mask="'##'" placeholder="Day" name="dob_date"/>
                    </div>
                    <div class="fields dropdown dob-month" :class="{'has-error': errors.has(field.name) }" v-bind:key="3">
                        <div class="dropdown-inner">
                            <select v-model="dob.month" name="dob_month">
                                <option value="" disabled selected>Month</option>
                                <option v-for="(month, key) in Date.getMonths()" :value="key">{{ month }}</option>
                            </select>
                            <i class="fa fa-chevron-down"></i>
                        </div>
                    </div>
                    <div class="fields input dob-year" :class="{'has-error': errors.has(field.name) }" v-bind:key="4">
                        <input type="number" v-model="dob.year" v-mask="'####'" placeholder="Year" name="dob_year"/>
                    </div>

                    <div class="fields input hide" :class="{'has-error': errors.has(field.name) }" v-bind:key="5">
                        <input type="hidden" :id="field.name" :name="field.name" v-model="dateofbirth" v-validate="{ rules: { required: true, dateofbirth: true } }"/>
                    </div>
                </div>

                <textarea v-else-if="field.type == 'textarea'" :name="field.name" :id="field.name" maxlength="1250" v-validate="{ rules: ( required_fields[field.name] ? (required_fields[field.name]).join('|') : '' ) }" v-model="participant[field.name]"></textarea>

                <div class="selection-options" v-else-if="field.type == 'radio' && field.hasOwnProperty('values')">
                    <div class="fields selection" v-for="value in field.values" :class="{ 'checked': value.value == participant[field.name] && participant[field.name] != null, 'stacked': value.display.length >= 25  }">
                        <input type="radio" :name="field.name" :id="field.name+value.value" :value="value.value" v-validate="{ rules: ( required_fields[field.name] ? (required_fields[field.name]).join('|') : '' ) }" v-model="participant[field.name]">
                        <label :for="field.name+value.value">
                            <div class="checkbox">
                            </div>

                            <div class="title">
                                {{ value.display }}
                            </div>
                        </label>
                    </div>
                </div>
                <div class="selection-options" v-else-if="field.type == 'radio' && lookups[field.name]">
                    <div class="fields selection" v-for="value in lookups[field.name]" :class="{ 'checked': value.id == participant[field.name] && participant[field.name] != null, 'stacked': value.name.length >= 25  }">
                        <input type="radio" :name="field.name" :id="field.name+value.id" :value="value.id" v-validate="{ rules: ( required_fields[field.name] ? (required_fields[field.name]).join('|') : '' ) }" v-model="participant[field.name]">
                        <label :for="field.name+value.id">
                            <div class="checkbox">
                            </div>

                            <div class="title">
                                {{ value.name }}
                            </div>
                        </label>
                    </div>
                </div>

                <div class="selection-options" v-else-if="field.type == 'checkbox'">
                    <div class="fields selection" v-for="value in field.values" :class="{ 'checked': participant[field.name] == true, 'stacked': value.display.length >= 25 }">
                        <input type="checkbox" :name="field.name" :id="field.name+value.id" :value="value.id" v-validate="{ rules: ( required_fields[field.name] ? (required_fields[field.name]).join('|') : '' ) }" v-model="participant[field.name]">
                        <label :for="field.name+value.id">
                            <div class="checkbox">
                            </div>

                            <div class="title">
                                {{ value.display }}
                            </div>
                        </label>
                    </div>
                </div>

                <div class="fields input" v-else-if="field.type == 'text-autocomplete'">
                    <input type="text" :name="field.name" :id="field.name" :placeholder="field.placeholder" maxlength="45" v-validate="{ rules: ( required_fields[field.name] ? (required_fields[field.name]).join('|') : '' ) }" v-model="participant[field.name]" :list="field.name+'-list'"/>
                    <datalist :id="field.name+'-list'">
                        <option  v-for="option in field.options" :key="option.id" :value="option.name" />
                    </datalist>
                </div>

                <label v-else-if="field.type == 'label'" :name="field.name" v-validate="{ rules: ( required_fields[field.name] ? (required_fields[field.name]).join('|') : '' ) }">
                </label>

                <input v-else :name="field.name" :id="field.name" :placeholder="field.placeholder" maxlength="45" v-validate="{ rules: ( required_fields[field.name] ? (required_fields[field.name]).join('|') : '' ) }" v-model="participant[field.name]">
                <p class="text-danger" v-if="errors.has(field.name)">{{ errors.first(field.name) }}</p>
            </div>
        </transition-group>
    </div>
</template>

<script>
    import VueSelect from 'vue-select'
    export default {
//        inject: ['$validator'],
        props: ['required_fields', 'participant', 'dob', 'dateofbirth', 'lookups', 'data', 'step'],
        components: {'v-select': VueSelect},
        data () {
            return {
                schools: [],
                school: "",
            }
        },
        watch: {
            "school": () => {
                //
            },
        },
        methods: {
            newSchoolChosen (school) {
                if(school != null) {
                    this.participant.school_id = (school instanceof Object ? school.id : school);
                    this.participant.school_readable = (school instanceof Object ? school.name : this.participant.school_readable );

                    this.school = school.name;
                } else {
                    this.participant.school_id = null;
                    this.participant.school_readable = "";
                    this.school = "";
                    this.$validator.validateAll().then(() => {
                    }).catch(error => {
                    });
                }
            },
            getSchools: _.debounce(
                function(search, loading) {
                    if(search.length < 2)
                        return false;

                    loading(true);
                    axios.get('/camp-booking/lookups/schools?filter='+search)
                        .then(response => {
                            this.schools = [];
                            response.data.data.forEach(school => {
                                school.name = school.name + ' (' + school.town + ')';
                                this.schools.push(school);
                            })
                            loading(false);
                        });
                },
                500
            ),
        },
        created () {
            if(this.data[0].name == 'school_id') {

                /**
                 * School validation
                 **/
                this.$validator.remove('validschool');// Want to remove it incase it already exists.
                this.$validator.extend('validschool', {
                    getMessage: field => this.$root.locale.participant.form.school_id.error,
                    validate: value => true//(this.school != null && this.school != "") || (this.participant.non_uk_school_name != null && this.participant.non_uk_school_name != "")
                });
            }

            if(this.data[0].name == 'non_uk_school_name') {

                /**
                 * Non UK School validation
                 **/
                this.$validator.remove('validschool');// Want to remove it incase it already exists.
                this.$validator.extend('validschool', {
                    getMessage: field => this.$root.locale.participant.form.non_uk_school_name.error,
                    validate: value => true//(this.school != null && this.school != "") || (this.participant.non_uk_school_name != null && this.participant.non_uk_school_name != "")
                });
            }
        },
        computed: {
            shouldShowTshirtSize() {
            return this.formData.age > 15;
            }
        },
    }
</script>



// WEBPACK FOOTER //
// ParticipantField.vue?553f99c7